/* eslint-disable @typescript-eslint/no-unused-vars */
import React, { useState } from 'react';
import { Statement, TextEffect } from '@/customTypes/chatStory';
import FullImageContainer from '../../../storyCommon/FullImageContainer';
import TextEffectOnImage from '@/components/storyCommon/TextEffectOnImage';

interface IChatItem {
  statement: Statement;
  onClickImage?: (e: React.MouseEvent<HTMLDivElement, MouseEvent>) => void;
}

const FullWidthImage = ({ statement, onClickImage }: IChatItem) => {
  const [imageWidth, setImageWidth] = useState<number>(0);
  const [imageHeight, setImageHeight] = useState<number>(0);

  const effects: TextEffect[] | undefined = statement?.option?.effects;

  const setImageSize = (width: number, height: number) => {
    setImageWidth(width);
    setImageHeight(height);
  };

  return (
    <FullImageContainer
      imageWidth={statement?.width}
      imageHeight={statement?.height}
      imageURL={statement.link}
      setImageSize={setImageSize}
      onClickImage={onClickImage}
      hasTopMargin={true}
    >
      <>
        {effects?.map((effect, index) => {
          return (
            <TextEffectOnImage
              key={`${effect.content}_${index}`}
              effect={effect}
              size={{
                width: imageWidth,
                height: imageHeight,
              }}
              originSize={{
                width: statement.width,
                height: statement.height,
              }}
            />
          );
        })}
      </>
    </FullImageContainer>
  );
};

export default FullWidthImage;
